import React, { useCallback, useRef, useState } from 'react';
import { FormHandles } from '@unform/core';
import {
  Box,
  Flex,
  Heading,
  Stack,
  Text,
  useBreakpointValue,
} from '@chakra-ui/react';

import Form from 'Components/Atoms/Form';
import Input from 'Components/Atoms/Input';
import Button from 'Components/Atoms/Button';
import NavLink from 'Components/Atoms/NavLink';
import { usePassword } from 'Hooks/password';
import IRecoveryPasswordData from 'Types/DTOs/IRecoveryPasswordData';

const RecoveryPasswordForm: React.FC = () => {
  const { recoveryPassword } = usePassword();

  const formRef = useRef<FormHandles>(null);

  const [loading, setLoading] = useState(false);

  const containerWidth = useBreakpointValue({
    base: '100%',
    lg: 'initial',
  });
  const formWidth = useBreakpointValue({
    base: '100%',
    md: '300px',
  });

  const handleRequestRecoveryPassword = useCallback(
    async (data: IRecoveryPasswordData) => {
      setLoading(true);
      await recoveryPassword({ data, formRef });
      setLoading(false);
    },
    [recoveryPassword, formRef],
  );

  return (
    <Flex w={containerWidth} p="55px" justify="center" align="center">
      <Stack mx="20px" w={formWidth} spacing="40px">
        <Box>
          <Heading as="h1" size="lg" mb="15px">
            Recovery password
          </Heading>
          <Text>
            You have received a recovery token on your email, please use it to
            choose a new password!
          </Text>
        </Box>

        <Form
          ref={formRef}
          onSubmit={handleRequestRecoveryPassword}
          spacing="10px"
        >
          <Input
            placeholder="john_doe"
            label="Username"
            name="username"
            type="text"
          />
          <Input
            placeholder="X00X00X0"
            label="Token"
            name="token"
            type="text"
          />
          <Input
            placeholder="Secret"
            label="Password"
            name="password"
            type="password"
          />
          <Input
            placeholder="Secret"
            label="Confirm password"
            name="confirm_password"
            type="password"
            mb="10px"
          />
          <Button isLoading={loading} type="submit" isPrimary>
            Update password
          </Button>
        </Form>

        <Flex justifyContent="center">
          <NavLink text="Back to sign in" to="/" />
        </Flex>
      </Stack>
    </Flex>
  );
};

export default RecoveryPasswordForm;
